import { useEffect, useState } from "@discovery/common-dplus/lib/hooks";
export const goBackToPreviousPage = () => {
    window.history.back();
};
export const navigateTo = (url) => {
    window.location.href = url;
};
export const getPathname = () => {
    return window.location.pathname.split("/")[1];
};
export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const debounceDelayTimeHandler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(debounceDelayTimeHandler);
        };
    }, [value, delay]);
    return debouncedValue;
};
export const isHTMLInputElement = (target) => {
    return target instanceof HTMLInputElement;
};
export const validateFirstname = (name) => {
    const re = new RegExp("^[a-zA-Z0-9]+(([',. -][a-zA-Z0-9 ])?[a-zA-Z0-9]*)(?=.{0,20})");
    return re.test(String(name));
};
export const validateLastname = (name) => {
    const re = new RegExp("^[a-zA-Z0-9]+(([',. -][a-zA-Z0-9 ])?[a-zA-Z0-9]*)(?=.{0,20})");
    return re.test(String(name));
};
export const getUrlParameter = (name) => {
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(location.search);
    return results === null
        ? ""
        : results[1] && decodeURIComponent(results[1].replace(/\+/g, " "));
};
export const formatAMPM = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? 0 + minutes : minutes;
    const strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
};
export const scrollToTop = () => {
    return window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};
